export const useIsInsideIbis = () => {
  return window.location.origin === process.env.REACT_APP_IBIS_URL;
};
